// extracted by mini-css-extract-plugin
export default {"container":"MatchEvents_container__VA7Qu","name":"MatchEvents_name__8sFN3","time":"MatchEvents_time__88glm"};